import { Box, useMediaQuery, useTheme } from '@mui/material';
import { FunctionComponent } from 'react';
import { CustomerSelector } from '../../../customers/components/CustomerSelector/CustomerSelector';
import { LanguageSelector } from '../LanguageSelector/LanguageSelector';
import { LogoutButton } from '../LogoutButton/LogoutButton';

export const DesktopHeaderMenu: FunctionComponent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only('xs'));
  return !isMobile
    ? <Box sx={{ position: 'absolute', top: 0, right: 0, zIndex: 402, display: 'flex' }}>
      <LanguageSelector />
      <CustomerSelector />
      <LogoutButton />
    </Box>
    : null;
};
